import { useEffect, useState } from "react";
import { fetchStoryDetail } from "../../action/banner";
import {
  fetchDistricts,
  fetchGaons,
  fetchStates,
  fetchSubDistricts,
} from "../../action/location";
import { useFormik } from "formik";
import Select from "react-select";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Link, useParams } from "react-router-dom";
import { Loader } from "../../components/loader";
const AdminStoryDetail = () => {
  const [data, setData] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [gaonList, setGaonList] = useState([]);
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [blockId, setBlockId] = useState("");
  const [gaonId, setGaonId] = useState("");
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const getStoryDetails = async () => {
    setLoading(true);
    const res = await fetchStoryDetail(id);
    console.log("response", res.data);
    if (res.status) {
      setLoading(false);
      setData(res?.data);
      setStateId(res.data.stateDetails?._id);
      setDistrictId(res.data.districtDetails?._id);
      setBlockId(res.data.blockDetails?._id);
      setGaonId(res.data.gaonId);
      setType(res.data.assets?.type);
    }
  };
  const getState = async () => {
    const res = await fetchStates();
    if (res.status) {
      const arr = res?.data.map((data) => {
        return { value: data._id, label: data.name };
      });
      setStates(arr);
    }
  };
  const getDistrict = async () => {
    const res = await fetchDistricts(stateId);
    if (res.status) {
      const arr = res?.data.map((data) => {
        return { value: data._id, label: data.name };
      });
      setDistricts(arr);
    }
  };
  const getSubDistrict = async () => {
    const res = await fetchSubDistricts(districtId);
    if (res.status) {
      const arr = res?.data.map((data) => {
        return { value: data._id, label: data.name };
      });
      setBlocks(arr);
    }
  };
  const fetchGaonList = async () => {
    const response = await fetchGaons(blockId);
    if (response.status) {
      const arr = response?.data.map((data) => {
        return { value: data._id, label: data.name };
      });
      setGaonList(arr);
    }
  };

  useEffect(() => {
    getState();
  }, [type]);
  useEffect(() => {
    getDistrict();
  }, [stateId]);
  useEffect(() => {
    getSubDistrict();
  }, [districtId]);
  useEffect(() => {
    fetchGaonList();
  }, [blockId]);
  useEffect(() => {
    getStoryDetails();
  }, []);

  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              {" "}
              <Breadcrumb
                paths={[
                  {
                    name: "Story",
                    link: `/admin/story-list`,
                  },
                  { name: "Story detail" },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="add_buyer_content">
            <div className="row">
              <div className="col-lg-6">
                <div className="input-box">
                  <div className="input-label">Type</div>
                  <div className="input_field">
                    <select
                      className="input"
                      required
                      disabled
                      isDisabled={true}
                      name="type"
                      placeholder="Enter Title"
                      value={data.assets?.type}>
                      <option value="">Please Select Type...</option>
                      <option value="2">IMAGE</option>
                      <option value="1">VIDEO</option>
                      <option value="0">TEXT</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="input-box">
                  <div className="input-label">View Count</div>
                  <div className="input_field">
                    <input
                      className="input"
                      required
                      name="title"
                      placeholder="Enter Title"
                      value={data.viewCount}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              {(data.assets?.type == 1 || data.assets?.type == 2) && (
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Caption</div>
                    <div className="input_field">
                      <input
                        className="input"
                        required
                        readOnly
                        name="title"
                        placeholder="Enter Title"
                        value={data.title}
                      />
                    </div>
                  </div>
                </div>
              )}

              {data.assets?.type == 0 ? (
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Caption</div>
                    <div className="input_field">
                      <input
                        className="input"
                        required
                        readOnly
                        name="title"
                        placeholder="Enter Title"
                        value={data.assets.url}
                      />
                    </div>
                  </div>
                </div>
              ) : data.assets?.type == 2 ? (
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Image</div>
                    <img
                      src={process.env.REACT_APP_S3_URL + "/" + data.assets.url}
                      alt=""
                      style={{ height: "250px" }}
                    />
                  </div>
                </div>
              ) : (
                data.assets?.type == 1 && (
                  <div className="col-lg-6">
                    <div className="input-box">
                      <div className="input-label">Video</div>
                      <video
                        width="300"
                        controls>
                        <source
                          src={
                            process.env.REACT_APP_S3_URL + "/" + data.assets.url
                          }
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                )
              )}
              <div className="row">
                <div className="col-lg-6">
                  <div className="d-flex w-full gap-5 mt-5 story_label_box">
                    <div className="input-label">Is Public</div>
                    <div className="d-flex gap-4">
                      <label>
                        <input
                          type="radio"
                          name="isPublic"
                          className="mx-2"
                          value="true"
                          checked={data.isPublic === true}
                          disabled // ✅ Disables the radio button
                        />
                        Yes
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="isPublic"
                          className="mx-2"
                          value="false"
                          checked={data.isPublic === false}
                          disabled // ✅ Disables the radio button
                        />
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {data.isPublic === false && (
                <>
                  <div className="col-lg-6">
                    <div className="input-box">
                      <div className="input-label">
                        State
                        <span>*</span>
                      </div>
                      <Select
                        name="stateId"
                        options={states} // Ensure states is an array [{ value: "id", label: "State Name" }]
                        isDisabled // Instead of readOnly, use isDisabled to prevent changes
                        value={
                          states.find((state) => state.value === stateId) ||
                          null
                        } // Preselect
                        className="basic-multi-select"
                        classNamePrefix="select"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-box">
                      <div className="input-label">
                        District
                        <span>*</span>
                      </div>
                      <Select
                        name="districtId"
                        options={districts}
                        isDisabled // Instead of readOnly, use isDisabled to prevent changes
                        value={
                          districts.find((data) => data.value == districtId) ||
                          null
                        } // Preselect
                        className="basic-multi-select"
                        classNamePrefix="select"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-box">
                      <div className="input-label">
                        Sub District
                        <span>*</span>
                      </div>
                      <Select
                        name="blockId"
                        options={blocks}
                        isDisabled
                        value={
                          blocks.find((data) => data.value == blockId) || null
                        } // Preselect
                        className="basic-multi-select"
                        classNamePrefix="select"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-box">
                      <div className="input-label">
                        Gaon
                        <span>*</span>
                      </div>
                      <Select
                        name="gaonId"
                        options={gaonList}
                        value={gaonList.find(
                          (state) => state.value === data.gaonId
                        )}
                        isDisabled={true} // ✅ Correct prop for React-Select
                        className="basic-multi-select"
                        classNamePrefix="select"
                        required
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="mt-3 flex_btn">
              <Link
                className="btn"
                style={{ color: "white", backgroundColor: "red" }}
                color="red"
                to={"/admin/story-list"}>
                <i className="fas fa-arrow-left"></i>
                &nbsp;&nbsp; Back
              </Link>
              {/* <button className="btn btn-success" type="submit">
                            Create
                        </button> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default AdminStoryDetail;
